<template>
  <div
    class="full-h mx-auto flex max-w-[1058px] flex-col items-center gap-y-[40px] laptop:flex-row laptop:gap-y-0 laptop:gap-x-[232px]"
  >
    <div class="flex w-[100px] flex-col text-center text-n400 laptop:w-[300px]">
      <div class=""><img src="/icons/eco-spots.svg" class="mx-auto h-[174px] w-[174px]" /></div>
      <p
        class="max-w-[180px] self-center laptop:max-w-full tablet:text-[17px] font-medium text-ng800 leading-[1.2] mt-[24px]"
      >
        {{ data?.companyPage?.data?.attributes?.environmentsocial_stats[0]?.text || "" }}
      </p>
    </div>
    <div class="flex w-[100px] flex-col text-center text-n400 laptop:w-[300px]">
      <div class=""><img src="/icons/zero-plastic.svg" class="mx-auto h-[174px] w-[174px]" /></div>
      <p
        class="max-w-[180px] self-center laptop:max-w-full tablet:text-[17px] font-medium text-ng800 leading-[1.2] mt-[24px]"
      >
        {{ data?.companyPage?.data?.attributes?.environmentsocial_stats[1]?.text || "" }}
      </p>
    </div>
    <div class="flex w-[100px] flex-col text-center text-n400 laptop:w-[300px]">
      <div class="">
        <img src="/icons/long-term-infrastracture.svg" class="mx-auto h-[174px] w-[174px]" />
      </div>
      <p
        class="max-w-[180px] self-center laptop:max-w-full tablet:text-[17px] font-medium text-ng800 leading-[1.2] mt-[24px]"
      >
        {{ data?.companyPage?.data?.attributes?.environmentsocial_stats[2]?.text || "2" }}
      </p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Companypage2DataKey } from "~/symbols/symbols";
const data = inject(Companypage2DataKey);
</script>
<style lang="scss" scoped></style>
